'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { Dropdown } from '../Dropdown/index.js';
import { TextPassage } from '../TextPassage/index.js';
import { Search } from '../Search/index.js';
import { BACKSPACE_KEYCODE } from '../../util/index.js';
export const AutocompleteSearch = (_a) => {
    var _b;
    var { className, placeholder, data, custom, children, revealOnFocus } = _a, other = __rest(_a, ["className", "placeholder", "data", "custom", "children", "revealOnFocus"]);
    const componentClassName = classnames('sparky-c-autocomplete', className, {});
    const sortedData = React.useMemo(() => data === null || data === void 0 ? void 0 : data.sort(), [data]);
    const autocompleteRef = React.useRef(null);
    const autoCompleteWrapper = React.useRef(null);
    const [isTyping, setIsTyping] = React.useState(false);
    const [isFocused, setIsFocused] = React.useState(false);
    const [suggestions, setSuggestions] = React.useState(sortedData);
    React.useEffect(() => {
        if (!autocompleteRef.current)
            return;
        autocompleteRef.current.addEventListener('keyup', (ev) => {
            var _a, _b, _c, _d, _e, _f;
            if (((_b = (_a = autocompleteRef === null || autocompleteRef === void 0 ? void 0 : autocompleteRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) &&
                autocompleteRef.current.value.length >= 1) {
                if (!((_c = autoCompleteWrapper === null || autoCompleteWrapper === void 0 ? void 0 : autoCompleteWrapper.current) === null || _c === void 0 ? void 0 : _c.getElementsByClassName('sparky-c-search__clear-button')))
                    return;
                (_e = (_d = autoCompleteWrapper === null || autoCompleteWrapper === void 0 ? void 0 : autoCompleteWrapper.current) === null || _d === void 0 ? void 0 : _d.querySelector('.sparky-c-search__clear-button')) === null || _e === void 0 ? void 0 : _e.addEventListener('click', () => {
                    setIsFocused(false);
                    setIsTyping(false);
                    setSuggestions(sortedData);
                });
                setIsTyping(true);
            }
            else {
                setIsTyping(false);
            }
            const regex = new RegExp(`^${(_f = autocompleteRef === null || autocompleteRef === void 0 ? void 0 : autocompleteRef.current) === null || _f === void 0 ? void 0 : _f.value}`, `i`);
            const event = ev;
            if (event.key === 'Delete' || event.code === BACKSPACE_KEYCODE) {
                setSuggestions(sortedData &&
                    sortedData
                        .filter((v) => regex.test(v))
                        .filter((i) => regex.test(i)));
            }
            else {
                setSuggestions(suggestions &&
                    suggestions
                        .filter((v) => regex.test(v))
                        .filter((i) => regex.test(i)));
            }
        }, false);
    }, [isTyping]);
    const searchTerm = (_b = autocompleteRef === null || autocompleteRef === void 0 ? void 0 : autocompleteRef.current) === null || _b === void 0 ? void 0 : _b.value;
    const searchTermRegex = new RegExp(`(${searchTerm && searchTerm.replace(/[.\\+*?[^\]$(){}=!<>|:-]/g, '\\$&')})`, 'gi');
    const selectValue = (value) => {
        if (autocompleteRef && autocompleteRef.current) {
            autocompleteRef.current.value = value;
        }
        setIsFocused(false);
        setIsTyping(false);
    };
    const getBoldFilteredText = (text, term) => {
        const substrings = text.split(searchTermRegex);
        return (_jsx(TextPassage, Object.assign({ className: "sparky-c-autocomplete__options", onClick: () => selectValue(text) }, { children: substrings.map((substring, index) => substring.toLowerCase() === (term === null || term === void 0 ? void 0 : term.toLowerCase()) ? (_jsx("strong", { children: substring }, index)) : (_jsx("span", { children: substring }, index))) }), text));
    };
    const onInputFocus = () => {
        revealOnFocus && setIsFocused(true);
    };
    const onInputBlur = () => {
        setTimeout(() => {
            setIsFocused(false);
            setIsTyping(false);
        }, 200);
    };
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { ref: autoCompleteWrapper }, { children: [_jsx(Search, { placeholder: placeholder, ref: autocompleteRef, onFocus: onInputFocus, onBlur: onInputBlur, label: "Search" }), (isTyping || isFocused) && (_jsx(Dropdown, Object.assign({ className: "sparky-c-autocomplete__dropdown" }, { children: custom
                    ? children
                    : isTyping
                        ? suggestions &&
                            suggestions.map((s) => getBoldFilteredText(s, searchTerm))
                        : suggestions &&
                            suggestions.map((s, index) => (_jsx(TextPassage, Object.assign({ className: "sparky-c-autocomplete__options", onClick: () => selectValue(s) }, { children: s }), index))) })))] })));
};
//# sourceMappingURL=AutocompleteSearch.js.map